module.exports = __webpack_public_path__ + "assets/img/Nathan.06ecc71d.jpg";